import { FeatureRedFishProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/features/redfish/FeatureRedFishProperties";
import { DEG_TO_RAD, Point } from "pixi.js";
export class FeatureRedFishPortraitProperties extends FeatureRedFishProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.logoProperties.anchor.set(0.5, 0.5);
        this.logoProperties.position.set(430, 130);
        this.logoProperties.scale.set(0.8);
        this.logoProperties.visible = true;
        this.titleText.position = new Point(512, 450);
        this.helpText.position = new Point(512, 1000);
        this.titleText.scale.set(1);
        this.helpText.scale.set(1);
        this.background.position.set(512, 973);
        this.cat.scale.set(1, 1);
        this.cat.position.set(512, 1293);
        this.boxLeft.position.set(512, 961);
        this.boxMiddle.position.set(512, 961);
        this.boxRight.position.set(512, 961);
        this.crowd[0].position.set(-80, 2268);
        this.crowd[1].position.set(360, 2268);
        this.crowd[2].position.set(550, 2268);
        this.crowd[3].position.set(715, 2268);
        this.crowd[4].position.set(1132, 2268);
        this.paddles[0].position.set(-180, 1840);
        this.paddles[1].position.set(360, 1840);
        this.paddles[2].position.set(550, 1840);
        this.paddles[3].position.set(654, 1840);
        this.paddles[4].position.set(1096, 1840);
        this.paddles[0].rotation = 13.25 * DEG_TO_RAD;
        this.paddles[1].rotation = -1 * DEG_TO_RAD;
        this.paddles[2].rotation = -3 * DEG_TO_RAD;
        this.paddles[3].rotation = 5.75 * DEG_TO_RAD;
        this.paddles[4].rotation = -10.25 * DEG_TO_RAD;
        this.siameseCrowdCat.position.set(787, 1864);
    }
}
